import RestaurantIcon from "@mui/icons-material/Restaurant";
import LocalDiningIcon from "@mui/icons-material/LocalDining";
import FastfoodIcon from "@mui/icons-material/Fastfood";
import LocalCafeIcon from "@mui/icons-material/LocalCafe";
import LocalBarIcon from "@mui/icons-material/LocalBar";
import BakeryDiningIcon from "@mui/icons-material/BakeryDining";
import TakeoutDiningIcon from "@mui/icons-material/TakeoutDining";
import LocalPizzaIcon from "@mui/icons-material/LocalPizza";
import RiceBowlIcon from "@mui/icons-material/RiceBowl";
import RamenDiningIcon from "@mui/icons-material/RamenDining";
import KebabDiningIcon from "@mui/icons-material/KebabDining";
import OutdoorGrillIcon from "@mui/icons-material/OutdoorGrill";
import WaterDropIcon from "@mui/icons-material/WaterDrop";
import LocalFloristIcon from "@mui/icons-material/LocalFlorist";
import EggIcon from "@mui/icons-material/Egg";
import LocalGroceryStoreIcon from "@mui/icons-material/LocalGroceryStore";
import SoupKitchenIcon from "@mui/icons-material/SoupKitchen";
import SetMealIcon from "@mui/icons-material/SetMeal";
import BreakfastDiningIcon from "@mui/icons-material/BreakfastDining";
import LunchDiningIcon from "@mui/icons-material/LunchDining";
import DinnerDiningIcon from "@mui/icons-material/DinnerDining";
import FreeBreakfastIcon from "@mui/icons-material/FreeBreakfast";
import CakeIcon from "@mui/icons-material/Cake";
import IcecreamIcon from "@mui/icons-material/Icecream";
import EmojiFoodBeverageIcon from "@mui/icons-material/EmojiFoodBeverage";
import LiquorIcon from "@mui/icons-material/Liquor";
import SportsBarIcon from "@mui/icons-material/SportsBar";
import MenuBookIcon from "@mui/icons-material/MenuBook";

export const FOOD_TYPE_ICONS = [
  // General Establishments
  {
    id: "RestaurantIcon",
    label: "Restaurante Geral",
    icon: RestaurantIcon,
    color: "#1976d2",
    category: "Estabelecimentos",
  },
  {
    id: "LocalDiningIcon",
    label: "Restaurante Fino",
    icon: LocalDiningIcon,
    color: "#7b1fa2",
    category: "Estabelecimentos",
  },
  {
    id: "FastfoodIcon",
    label: "Fast Food",
    icon: FastfoodIcon,
    color: "#f57c00",
    category: "Estabelecimentos",
  },
  {
    id: "LocalCafeIcon",
    label: "Café & Cafeteria",
    icon: LocalCafeIcon,
    color: "#5d4037",
    category: "Estabelecimentos",
  },
  {
    id: "LocalBarIcon",
    label: "Bar & Pub",
    icon: LocalBarIcon,
    color: "#388e3c",
    category: "Estabelecimentos",
  },
  {
    id: "BakeryDiningIcon",
    label: "Padaria",
    icon: BakeryDiningIcon,
    color: "#ff9800",
    category: "Estabelecimentos",
  },
  {
    id: "TakeoutDiningIcon",
    label: "Delivery/Takeout",
    icon: TakeoutDiningIcon,
    color: "#009688",
    category: "Estabelecimentos",
  },

  // Specific Cuisines
  {
    id: "LocalPizzaIcon",
    label: "Pizzaria",
    icon: LocalPizzaIcon,
    color: "#d32f2f",
    category: "Cozinhas",
  },
  {
    id: "RiceBowlIcon",
    label: "Comida Asiática",
    icon: RiceBowlIcon,
    color: "#4caf50",
    category: "Cozinhas",
  },
  {
    id: "RamenDiningIcon",
    label: "Ramen & Noodles",
    icon: RamenDiningIcon,
    color: "#ff5722",
    category: "Cozinhas",
  },
  {
    id: "KebabDiningIcon",
    label: "Comida Árabe/Turca",
    icon: KebabDiningIcon,
    color: "#795548",
    category: "Cozinhas",
  },
  {
    id: "OutdoorGrillIcon",
    label: "Churrascaria/Grill",
    icon: OutdoorGrillIcon,
    color: "#8d6e63",
    category: "Cozinhas",
  },

  // Specific Food Types
  {
    id: "WaterDropIcon",
    label: "Frutos do Mar/Peixe",
    icon: WaterDropIcon,
    color: "#0277bd",
    category: "Tipos de Comida",
  },
  {
    id: "LocalFloristIcon",
    label: "Vegetariano/Vegano",
    icon: LocalFloristIcon,
    color: "#8bc34a",
    category: "Tipos de Comida",
  },
  {
    id: "EggIcon",
    label: "Ovos/Proteínas",
    icon: EggIcon,
    color: "#ffc107",
    category: "Tipos de Comida",
  },
  {
    id: "LocalGroceryStoreIcon",
    label: "Frutas/Natural",
    icon: LocalGroceryStoreIcon,
    color: "#4caf50",
    category: "Tipos de Comida",
  },
  {
    id: "SoupKitchenIcon",
    label: "Sopas/Caldos",
    icon: SoupKitchenIcon,
    color: "#ff7043",
    category: "Tipos de Comida",
  },
  {
    id: "SetMealIcon",
    label: "Refeições Completas",
    icon: SetMealIcon,
    color: "#5d4037",
    category: "Tipos de Comida",
  },

  // Meal Times
  {
    id: "BreakfastDiningIcon",
    label: "Café da Manhã",
    icon: BreakfastDiningIcon,
    color: "#ffc107",
    category: "Horários",
  },
  {
    id: "LunchDiningIcon",
    label: "Almoço",
    icon: LunchDiningIcon,
    color: "#03a9f4",
    category: "Horários",
  },
  {
    id: "DinnerDiningIcon",
    label: "Jantar",
    icon: DinnerDiningIcon,
    color: "#673ab7",
    category: "Horários",
  },
  {
    id: "FreeBreakfastIcon",
    label: "Brunch",
    icon: FreeBreakfastIcon,
    color: "#ff8a65",
    category: "Horários",
  },

  // Desserts & Sweets
  {
    id: "CakeIcon",
    label: "Bolos/Confeitaria",
    icon: CakeIcon,
    color: "#e91e63",
    category: "Doces",
  },
  {
    id: "IcecreamIcon",
    label: "Sorveteria",
    icon: IcecreamIcon,
    color: "#00bcd4",
    category: "Doces",
  },

  // Beverages
  {
    id: "EmojiFoodBeverageIcon",
    label: "Bebidas & Lanches",
    icon: EmojiFoodBeverageIcon,
    color: "#607d8b",
    category: "Bebidas",
  },
  {
    id: "LiquorIcon",
    label: "Destilados/Coquetéis",
    icon: LiquorIcon,
    color: "#9c27b0",
    category: "Bebidas",
  },
  {
    id: "SportsBarIcon",
    label: "Cervejaria",
    icon: SportsBarIcon,
    color: "#ff9800",
    category: "Bebidas",
  },

  // Special Categories
  {
    id: "MenuBookIcon",
    label: "Cardápio Variado",
    icon: MenuBookIcon,
    color: "#37474f",
    category: "Especiais",
  },
];
